import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=3029c01c&scoped=true&"
import script from "./shouye.vue?vue&type=script&lang=js&"
export * from "./shouye.vue?vue&type=script&lang=js&"
import style0 from "./shouye.vue?vue&type=style&index=0&id=3029c01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029c01c",
  null
  
)

export default component.exports